import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { track } from '@/lib/analytics';
import { setOnboardingStepDone } from '@/lib/storage';
import { OnboardingProgress } from '@/components/OnboardingProgress';
import { Button } from '@/components';
import { FiDollarSign, FiCalendar, FiFileText } from 'react-icons/fi';

const TOTAL_STEPS = 11;

const FEATURES = [
  { icon: FiDollarSign, text: 'Track shared expenses' },
  { icon: FiCalendar, text: 'Share custody schedules' },
  { icon: FiFileText, text: 'Keep court-ready records' },
];

function WelcomePage() {
  const navigate = useNavigate();

  useEffect(() => {
    track('Welcome Value Screen');
  }, []);

  const handleContinue = () => {
    track('Welcome Value Continue Tapped');
    setOnboardingStepDone('welcome');
    navigate({ to: '/app/onboarding/social-proof' });
  };

  return (
    <div className='min-h-screen bg-sky-light flex flex-col'>
      <OnboardingProgress currentStep={1} totalSteps={TOTAL_STEPS} />
      <div className='flex-1 flex flex-col items-center justify-between px-6 max-w-lg mx-auto w-full'>
        <div className='flex-1 flex flex-col items-center justify-center'>
          <h1
            className='text-4xl font-extrabold text-gray-900 text-center leading-tight'
            style={{
              fontFamily:
                "'Nunito', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
            }}
          >
            Co-parenting
            <br />
            made peaceful
          </h1>
          <p
            className='mt-4 text-lg text-gray-500 text-center leading-relaxed'
            style={{
              fontFamily:
                "'Nunito', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
            }}
          >
            Everything you need to co-parent effectively, all in one place.
          </p>

          <div className='mt-10 space-y-4'>
            {FEATURES.map((feature, index) => {
              const Icon = feature.icon;
              return (
                <div key={index} className='flex items-center gap-3.5'>
                  <div className='w-12 h-12 rounded-[14px] bg-primary/[0.08] flex items-center justify-center'>
                    <Icon className='w-6 h-6 text-primary' />
                  </div>
                  <span
                    className='text-[17px] font-semibold text-gray-900'
                    style={{
                      fontFamily:
                        "'Nunito', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
                    }}
                  >
                    {feature.text}
                  </span>
                </div>
              );
            })}
          </div>
        </div>

        <div className='w-full pb-6 pt-4'>
          <Button fullWidth onClick={handleContinue}>
            Get Started
          </Button>
        </div>
      </div>
    </div>
  );
}

export const Route = createFileRoute('/app/onboarding/welcome')({
  component: WelcomePage,
});
